import { useState, useCallback } from 'react';

interface UsePrizeStepNavigationProps {
    initialStep: number;
    maxStep: number;
}

export const usePrizeStepNavigation = ({ initialStep, maxStep }: UsePrizeStepNavigationProps) => {
    const [step, setStep] = useState<number>(initialStep);

    const goToStep = useCallback(
        (targetStep: number) => {
            if (targetStep <= maxStep) {
                setStep(targetStep);
            }
        },
        [maxStep]
    );

    const goToNextStep = useCallback(() => {
        const nextStep = step + 1;
        if (nextStep <= maxStep) {
            setStep(nextStep);
        }
    }, [step, maxStep]);

    const goToPreviousStep = useCallback(() => {
        const previousStep = step - 1;
        if (previousStep >= 1) {
            setStep(previousStep);
        }
    }, [step]);

    const resetToStep = useCallback(
        (targetStep: number) => {
            if (targetStep <= maxStep) {
                setStep(targetStep);
            }
        },
        [maxStep]
    );

    return {
        step,
        goToStep,
        goToNextStep,
        goToPreviousStep,
        resetToStep,
        canGoNext: step < maxStep,
        canGoPrevious: step > 1,
        maxStep
    };
};
